import React, { useEffect, useState } from "react";
import { getNetworkRoles } from "../../../../containers/actions/netwrokActions";
import { GET_NETWORK_ROLES_LOADING } from "../../../../containers/actions/types";
import { useDispatch, useSelector } from "react-redux";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
// import {
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Typography,
// } from '@mui/material';

import {
  CircularProgress,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
} from "@material-ui/core";

// const getRoles = {
//   status: "success",
//   data: {
//     sponsorRoles: [
//       { role_name: "External Manufacturing Service Manager", collaborator_role_id: "01", roleType: "Sponsor" },
//       { role_name: "Procurement Manager", collaborator_role_id: "02", roleType: "Sponsor" },
//       { role_name: "Procurement Manager, Packaging", collaborator_role_id: "03", roleType: "Sponsor" },
//       { role_name: "Site Manager", collaborator_role_id: "04", roleType: "Sponsor" },
//       { role_name: "Global Supply Chain Planning Head", collaborator_role_id: "05", roleType: "Sponsor" },
//       { role_name: "Global Supply Chain Planning Manager", collaborator_role_id: "06", roleType: "Sponsor" },
//       { role_name: "Quality Assurance Head", collaborator_role_id: "07", roleType: "Sponsor" },
//       { role_name: "Quality Assurance Manager", collaborator_role_id: "08", roleType: "Sponsor" },
//       { role_name: "Distribution Manager", collaborator_role_id: "09", roleType: "Sponsor" },
//     ],
//     cmoRoles: [
//       { role_name: "Production Planning Manager", collaborator_role_id: "01", roleType: "CMO" },
//       { role_name: "Inventory Manager", collaborator_role_id: "02", roleType: "CMO" },
//       { role_name: "Procurement Manager", collaborator_role_id: "03", roleType: "CMO" },
//       { role_name: "Production Manager", collaborator_role_id: "04", roleType: "CMO" },
//       { role_name: "Quality Manager", collaborator_role_id: "05", roleType: "CMO" },
//       { role_name: "Business Development Manager", collaborator_role_id: "06", roleType: "CMO" },
//     ]
//   }
// };

const useStyles = makeStyles((theme) => ({
  inline: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  table: {
    maxWidth: 650,
    border: "1px solid #e0e0e0", // Light gray border for the table
    marginTop: 10,
    backgroundColor: "#fff", // Ensure table background is white
  },
  tableHeader: {
    backgroundColor: "#F1F1F5", // Slightly darker background for the header
    fontWeight: 600,
    fontWeight: 400, // Ensure regular font-weight for body cells
    color: "#000", // Solid black text
    //color: "#333", // Darker text color for better contrast
  },
      saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
       width: "12rem",
      fontSize: "1rem",
      fontWeight: 550,
        cursor: "pointer",
                // paddingLeft:"3rem",
                // paddingRight:"3rem",
       paddingTop: "0.35rem",
                paddingBottom: "0.35rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton:{
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
       width: "12rem",
      fontSize: "1rem",
      fontWeight: 550,
        cursor: "pointer",
                // paddingLeft:"3rem",
                // paddingRight:"3rem",
       paddingTop: "0.35rem",
                paddingBottom: "0.35rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
  // tableCell: {
  //   padding: "8px 16px",
  //   fontSize: "0.875rem",
  //   color: "#555", // Neutral text color
  //   backgroundColor: "transparent", // Ensure no background color for body cells
  // },
  tableCell: {
    padding: "8px 16px",
    fontSize: "0.875rem",
    fontWeight: 400, // Ensure regular font-weight for body cells
    color: "#000", // Solid black text
    // color: "#555",
    borderBottom: "1px solid #e0e0e0", // horizontal lines only
  },
  headerCellNoBorder: {
    borderRight: "none", // removes vertical borders between header cells
    "&:last-child": {
      borderRight: "none",
    },
  },
  smallCell: {
    padding: "4px 8px",
    fontSize: "0.875rem",
  },
  urlField: {
    marginTop: 20,
    maxWidth: 400,
  },
  actions: {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between",
    maxWidth: 650,
  },
}));

const RoleManagement = ({
  activeTab,
  setActiveTab,
  handleNext,
  addSponsorList,
  rowData,
  updateNetworkData,
  setUpdateNetworkData,
  rowNetwork,
  existingSponsorFlow,
  networkURL
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const getRoles = useSelector((state) => state?.network?.getAllRoles || []);

  const getRolesLoading = useSelector(
    (state) => state?.network?.getAllRolesLoading
  );

  let fetchViewSponsorData = useSelector(
    (state) => state?.network?.selectedSponsorDetails?.SponsorDetails || []
  );


  useEffect(() => {
    dispatch({
      type: GET_NETWORK_ROLES_LOADING,
      payload: true,
    });
  //   if(addSponsorList?.data){
  //   dispatch(
  //     getNetworkRoles({
  //      ecosystemId:addSponsorList?.data?.ecosystemId})   
  //   );
  // }

  const ecosystemUrl = updateNetworkData?.ecosystemUrl || rowData?.networkURL
  const network = rowNetwork || addSponsorList?.data?.network || rowData?.network




  

  if (existingSponsorFlow && (rowData?.ecosystemId || addSponsorList?.data?.ecosystemId))  {
    if (ecosystemUrl && network) {
    dispatch(
      getNetworkRoles({
        ecosystemId: rowData?.ecosystemId || addSponsorList?.data?.ecosystemId,
        network: fetchViewSponsorData[0]?.network || updateNetworkData?.network || rowData?.network,
        ecosystemUrl: updateNetworkData?.ecosystemUrl || fetchViewSponsorData[0]?.networkURL || networkURL,
      }) 
    )
  }

    return;
  }

   if (ecosystemUrl && network) {
    if (rowData?.status === "Pending" && rowData?.ecosystemId &&
      (Array.isArray(addSponsorList) && addSponsorList.length === 0)
    ) {
      dispatch(getNetworkRoles({
        ecosystemId:rowData.ecosystemId,
         network,
         ecosystemUrl,
      }));
    } else if (addSponsorList?.data?.ecosystemId) {
      dispatch(getNetworkRoles({
         ecosystemId :addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
         network:addSponsorList?.data?.network || rowData?.network,
         ecosystemUrl:updateNetworkData?.ecosystemUrl || rowData?.networkURL,
      }));
    }
   }

  }, [rowNetwork, updateNetworkData?.ecosystemUrl, rowData?.networkURL, addSponsorList?.data?.ecosystemId, rowData?.ecosystemId, rowData?.status,rowData?.networkURL]);


  //   const handleSaveNext = () => {
  //     if (activeTab < 2) setActiveTab((prev) => prev + 1);
  // };

  // const handleSaveNext = () => {
  //   if (activeTab === 1) {
  //     const selectedIds = partnerTypes
  //       .map((item, index) => {
  //         const isActive = (item.activated && !deselectedIndices.includes(index)) ||
  //                          selectedIndices.includes(index);
  //         return isActive ? item.collaborator_type_id : null;
  //       })
  //       .filter(Boolean)
  //       .join(",");

  //     dispatch(updatePartnerType({
  //       partnerTypeIds: selectedIds,
  //       ecoSystemTypeID: initialNetworkTypes?.selectedNetworkTypeId,
  //       ecosystemID: 1,
  //     }));
  //   }

  //   if (activeTab < 2) {
  //     setActiveTab((prev) => prev + 1);
  //   }
  // };

  
  useEffect(() => {
    dispatch({
      type: GET_NETWORK_ROLES_LOADING,
      payload: true,
    });


    // if (rowData?.status === "Pending" && rowData?.ecosystemId &&
    //   (Array.isArray(addSponsorList) && addSponsorList.length === 0)
    // ) {
    //   dispatch(
    //     getNetworkRoles({
    //       ecosystemId: rowData.ecosystemId,
    //       network: rowData.network
    //     })
    //   );
    // }
    // else if (addSponsorList?.data?.ecosystemId) {
    //   const timeout = setTimeout(() => {
    //     dispatch(
    //       getNetworkRoles({
    //         ecosystemId: addSponsorList.data.ecosystemId,
    //         network: addSponsorList.data.network,
    //       })
    //     );

    //   }, 5000); // 5 seconds = 5000 milliseconds44


    // if (existingSponsorFlow && addSponsorList?.data?.ecosystemId)  {
    //   dispatch(
    //     getNetworkRoles({
    //       ecosystemId: addSponsorList?.data?.ecosystemId,
    //       network: fetchViewSponsorData[0]?.network || rowData?.network || addSponsorList?.data?.network,
    //       ecosystemUrl: fetchViewSponsorData[0]?.networkURL || networkURL,
    //     }) 
    //   )

    //   return;
    // }

    // dispatch(
    //   getNetworkRoles({
    //     ecosystemId: fetchViewSponsorData[0]?.ecosystemId || rowData?.ecosystemId || addSponsorList?.data?.ecosystemId,
    //     network: fetchViewSponsorData[0]?.network || rowData?.network || addSponsorList?.data?.network,
    //     ecosystemUrl: fetchViewSponsorData[0]?.networkURL || networkURL,
    //   }) 
    // )

      // Optional cleanup in case the component unmounts before timeout finishes
      // return () => clearTimeout(timeout);
    // }

    

      //  if(rowData?.status === "Pending"){
      //   dispatch(
      //     getNetworkRoles({
      //       ecosystemId: rowData?.ecosystemId,
      //     })
      //   );
      // }
  }, [fetchViewSponsorData[0]?.ecosystemId, fetchViewSponsorData[0]?.network, addSponsorList?.data?.ecosystemId, rowData?.ecosystemId, rowData?.network, rowData?.status, addSponsorList?.data?.network]);


  

  return (
    <>
      <div style={{ marginTop: "2rem" }}>
        <div
          style={{
            display: "flex",
            gap: "4rem",
            flexDirection: "row",
            lineHeight: "2rem",
          }}
        >
          {/* Sponsor Roles Table */}
          <div>
            <table
              style={{ borderCollapse: "collapse" }}
              cellPadding={6}
              className={classes.table}
            >
              <thead style={{ backgroundColor: "#F9F9FC" }}>
                <tr>
                  <th
                    // style={{ backgroundColor: "#F9F9FC" }}
                    className={`${classes.tableCell} ${classes.tableHeader} ${classes.headerCellNoBorder}`}
                    align="left"
                  >
                    Sponsor Role
                  </th>
                  <th
                    className={`${classes.tableCell} ${classes.tableHeader} ${classes.headerCellNoBorder}`}
                    align="right"
                  >
                    Sponsor Role ID
                  </th>
                </tr>
              </thead>
              {getRolesLoading === true ? (
                <tr style={{ height: 150 }}>
                  <td colSpan={12}>
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="primary" thickness={7} />
                    </div>
                  </td>
                </tr>
              ) : getRoles?.data?.sponsorRoles?.length > 0 ? (
                <tbody>
                  {getRoles?.data?.sponsorRoles.map((role, index) => (
                    <tr key={index}>
                      <td className={classes.tableCell} align="left">
                        {role.role_name}
                      </td>
                      <td className={classes.tableCell} align="right">
                        {role.collaborator_role_id}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (getRoles?.status === false || !getRoles?.status) ? (
                <tr
                  style={{
                    border: "2px solid rgb(255,0,0)",
                    backgroundColor: "rgb(255,240,240)",
                    Opacity: 1,
                    textAlign: "center",
                    padding: "0.8rem",
                    fontSize: "0.875rem",
                  }}
                >
                  <td align="center">
                    {"Something went wrong. Please contact Schrocken Support."}
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan={9} align="center">
                    No records found
                  </td>
                </tr>
              )}
            </table>
          </div>

          <div>
            <table
              style={{ borderCollapse: "collapse" }}
              cellPadding={6}
              className={classes.table}
            >
              <thead style={{ backgroundColor: "#F9F9FC" }}>
                <tr>
                  <th
                    className={`${classes.tableCell} ${classes.tableHeader} ${classes.headerCellNoBorder}`}
                    align="left"
                  >
                    CMO Role
                  </th>
                  <th
                    className={`${classes.tableCell} ${classes.tableHeader} ${classes.headerCellNoBorder}`}
                    align="right"
                  >
                    CMO Role ID
                  </th>
                </tr>
              </thead>
              {getRolesLoading === true ? (
                <tr style={{ height: 150 }}>
                  <td colSpan={12}>
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="primary" thickness={7} />
                    </div>
                  </td>
                </tr>
              ) : getRoles?.data?.cmoRoles?.length > 0 ? (
                <tbody>
                  {getRoles?.data?.cmoRoles.map((role, index) => (
                    <tr key={index}>
                      <td className={classes.tableCell} align="left">
                        {role.role_name}
                      </td>
                      <td className={classes.tableCell} align="right">
                        {role.collaborator_role_id}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (getRoles?.status === false  || !getRoles?.status) ? (
                <tr
                  style={{
                    border: "2px solid rgb(255,0,0)",
                    backgroundColor: "rgb(255,240,240)",
                    Opacity: 1,
                    textAlign: "center",
                    padding: "0.8rem",
                    fontSize: "0.875rem",
                  }}
                >
                  <td align="center">
                    {"Something went wrong. Please contact Schrocken Support."}
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan={9} align="center">
                    No records found
                  </td>
                </tr>
              )}
            </table>
          </div>
        </div>

        {/* <div style={{ marginTop: 30 }} className={classes.actions}>
            <Button variant="contained" disabled={activeTab === 0} onClick={() => setActiveTab((prev) => prev - 1)}>
              Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveNext}
              // disabled={ && activeTab === 0}
            >
              Save & Next
            </Button>
          </div> */}
      </div>

      <div style={{ marginTop: 30 }} className={classes.actions}>

                          <Grid
                  className={classes.backButton}
                    onClick={() => setActiveTab((prev) => prev - 1)}
                     disabled={activeTab === 0}
                     >
                   <ChevronLeftIcon />
                     Back
                 </Grid>
                    <Grid
                  className={classes.saveButton}
                   onClick={handleNext}
                     >
                      Save & Next
                    <ChevronRightIcon />
                    </Grid>
      </div>
    </>
  );
};

export default RoleManagement;
